import { useAuth0 } from '@auth0/auth0-react';

import logo from '@/assets/logo.svg';

export function Auth0WithoutPermission() {
  const session = useAuth0();
  return (
    <div className="hero min-h-screen bg-base-200">
      <div className="hero-content text-center">
        <div className="max-w-md px-4">
          <img src={logo} className="mx-auto w-64 h-48 object-contain mb-4" />

          <h2 className="text-2xl font-bold text-primary">oops! Lo siento, no tienes acceso</h2>

          <p className="py-6 text-base-content/80">
            La página a la que intentas acceder tiene acceso restringido.
            <br />
            Si eres un empleado de 99minutos por favor iniciar sesión con tu cuenta oficial.
          </p>

          <button
            className="btn btn-primary w-32 uppercase"
            onClick={() =>
              session.logout({
                logoutParams: { returnTo: window.location.origin },
              })
            }
          >
            Salir
          </button>
        </div>
      </div>
    </div>
  );
}
